import cn from "./configs/market/cn/hub.config";
import de from "./configs/market/de/hub.config";
import es from "./configs/market/es/hub.config";
import fr from "./configs/market/fr/hub.config";
import it from "./configs/market/it/hub.config";
import la from "./configs/market/la/hub.config";
import pt from "./configs/market/pt/hub.config";
import uk from "./configs/market/uk/hub.config";
import us from "./configs/market/us/hub.config";

// strings
import strings_de_DE from "./strings/strings.de-DE";
import strings_en_GB from "./strings/strings.en-GB";
import strings_en_US from "./strings/strings.en-US";
import strings_es_419 from "./strings/strings.es-419";
import strings_es_ES from "./strings/strings.es-ES";
import strings_fr_FR from "./strings/strings.fr-FR";
import strings_it_IT from "./strings/strings.it-IT";
import strings_pt_BR from "./strings/strings.pt-BR";
import strings_zh_CN from "./strings/strings.zh-CN";

export default ({ market, site, page, locale }) => {
    let strings;
    switch (locale) {
        case "de-DE":
            strings = strings_de_DE;
            break;
        case "en-GB":
            strings = strings_en_GB;
            break;
        case "es-419":
            strings = strings_es_419;
            break;
        case "es-ES":
            strings = strings_es_ES;
            break;
        case "fr-FR":
            strings = strings_fr_FR;
            break;
        case "it-IT":
            strings = strings_it_IT;
            break;
        case "pt-BR":
            strings = strings_pt_BR;
            break;
        case "zh-CN":
            strings = strings_zh_CN;
            break;
        default:
            strings = strings_en_US;
    }

    let config = {};
    switch (market.toString().toLowerCase()) {
        case "cn":
            return (config = cn({ market, site, page, locale, strings }));
        case "de":
            return (config = de({ market, site, page, locale, strings }));
        case "es":
            return (config = es({ market, site, page, locale, strings }));
        case "fr":
            return (config = fr({ market, site, page, locale, strings }));
        case "it":
            return (config = it({ market, site, page, locale, strings }));
        case "la":
            return (config = la({ market, site, page, locale, strings }));
        case "pt":
            return (config = pt({ market, site, page, locale, strings }));
        case "uk":
            return (config = uk({ market, site, page, locale, strings }));
        case "us":
            return (config = us({ market, site, page, locale, strings }));
    }
};
